;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.invoice.show')
    .controller('SendLitigationController', SendLitigationController)

  SendLitigationController.$inject = ['$uibModalInstance']

  function SendLitigationController ($uibModalInstance) {
    const self = this
    self.$onInit = () => {
      _.extend(self, {
        // Attributes
        // Methods
        cancel: cancel,
        accept: accept,
        refuse: refuse
      })
    }

    function accept () {
      $uibModalInstance.close(true)
    }

    function refuse () {
      $uibModalInstance.close(false)
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }
  }
})(window.angular, window._)
